import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';

//components
import withLocalization from '~/hoc/withLocalization';

//elements
import { NumberInput, Input } from '../../../../../elements/Input';
import SwitchWidget from '../../SwitchWidget';

//utils
import { currentYearCycle } from '../../../../../utils/commonMethods';

class ParentalLeaves extends Component {
    constructor(props) {
        super(props);
        const { currentEntity } = props.clientStore;
        const basicRules = Object.assign({}, currentEntity.client.data.basicRules);
        this.state = {
            parentalLeaves: {
                absencePeriodForTwoKids: basicRules.absencePeriodForTwoKids,
                absencePeriodForMoreThanTwoKids: basicRules.absencePeriodForMoreThanTwoKids,
                allowSingleParentCare: basicRules.allowSingleParentCare,
                absenceDaysForChildWithChronicCondtion: basicRules.absenceDaysForChildWithChronicCondtion
            },
        }
        this.handleChange = this.handleChange.bind(this)
        this.handleSwitch = this.handleSwitch.bind(this);
    }


    handleChange = (name, value) => {
        const { parentalLeaves } = this.state;
        parentalLeaves[name] = value;
        this.props.handleUserDataChange(name, value);
        this.setState({ parentalLeaves });
    }

    handleSwitch = (name, evt) => {
        const { parentalLeaves } = this.state;
        parentalLeaves[name] = evt;
        this.props.handleUserDataChange(name, evt);
        this.setState({ parentalLeaves })
    }

    render() {
        const { parentalLeaves } = this.state;
        const { t, commonStore } = this.props;
        const dateTimeRules = commonStore.getDateTimeRules();
        const { short_date_format } = dateTimeRules;
        const timezoneGMT = commonStore?.config?.timezoneGMT || 0;
        return (
            <div>
                <Row className='mt-2'>
                    <Col xs={12} md={6}>
                        <Row className='mt-2'>
                            <label className="control-label font-size-15 mt-2 font-color-primary">{t('Standard settings')}</label>
                        </Row>
                        <hr />
                        <Row className='mt-2 align-items-center'>
                            <Col xs={6}>
                                <label className="control-label">{t('Leave Cycle')}
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("The parental leave cycle follows the calendar year, and the leaves allocated to employees resets at the beginning of the year")}.
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={6}>
                                <Input
                                    disabled
                                    onChange={_ => { }}
                                    value={currentYearCycle(short_date_format, timezoneGMT)}
                                />
                            </Col>
                        </Row>
                        <Row className='mt-2 align-items-center'>
                            <Col xs={9}>
                                <label className="control-label">{t('Absence care days for single or two children')}
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("Parental leave days for parent with single or two children")}.
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={3}>
                                <NumberInput
                                    value={parentalLeaves.absencePeriodForTwoKids}
                                    onChange={evt => {
                                        this.handleChange('absencePeriodForTwoKids', parseInt(evt.target.value, 10));
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row className='mt-2 align-items-center'>
                            <Col xs={9}>
                                <label className="control-label">{t('Absence care days for more than two children')}
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("Parental leave days for parent with more than two children")}.
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={3}>
                                <NumberInput
                                    value={parentalLeaves.absencePeriodForMoreThanTwoKids}
                                    onChange={evt => {
                                        this.handleChange('absencePeriodForMoreThanTwoKids', parseInt(evt.target.value, 10));
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row className='mt-2 align-items-center'>
                            <Col xs={9}>
                                <label className="control-label">{t('Absence days for children with chronical illness')}
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("Parental leave for children with chronical illness, it will be accounted for each child chronical illness")}.
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={3}>
                                <NumberInput
                                    disabled
                                    value={parentalLeaves.absenceDaysForChildWithChronicCondtion}
                                    onChange={evt => {
                                        this.handleChange('absenceDaysForChildWithChronicCondtion', parseInt(evt.target.value, 10));
                                    }}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} md={6}>
                        <Row className='mt-2'>
                            <label className="control-label font-size-15 mt-2 font-color-primary">{t('Single parent leaves')}</label>
                        </Row>
                        <hr />
                        <Row className='mt-2 align-items-center'>
                            <Col xs={9}>
                                <label className="control-label me-1">{t('Allow extra care days for single parent')}</label>
                                <OverlayTrigger
                                    placement="bottom"
                                    overlay={
                                        <Tooltip id="tooltip-top">
                                            {t("This function allows employees who are single parents to apply for extra parental leave days. If a child has a chronic illness, the parent (employee) can apply for additional parental leave through the relevant welfare service or agency. However, the availability and rules for such leave may vary depending on the country's regulations and policies")}.
                                        </Tooltip>
                                    }>
                                    <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                </OverlayTrigger>
                            </Col>
                            <Col xs={3}>
                                <SwitchWidget
                                    className='mt-1'
                                    value={parentalLeaves.allowSingleParentCare}
                                    onChange={checked => this.handleSwitch('allowSingleParentCare', checked)} />
                            </Col>
                        </Row>
                        <Row className='mt-4 align-items-center'>
                            <Col xs={9}>
                                <label className="control-label">{t('Absence care days for single or two children for single parent')})
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("Parental leave days for parent with single or two children will be doubled if single parent care is enabled")}.
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={3}>
                                <NumberInput
                                    value={parentalLeaves.allowSingleParentCare ? parentalLeaves.absencePeriodForTwoKids * 2 : parentalLeaves.absencePeriodForTwoKids}
                                    onChange={_ => { }}
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className='mt-2 align-items-center'>
                            <Col xs={9}>
                                <label className="control-label">{t('Absence care days for more than two children for single parent')})
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("Parental leave days for parent with more than two children will be doubled if single parent care is enabled")}.
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={3}>
                                <NumberInput
                                    value={parentalLeaves.allowSingleParentCare ? parentalLeaves.absencePeriodForMoreThanTwoKids * 2 : parentalLeaves.absencePeriodForMoreThanTwoKids}
                                    onChange={_ => { }}
                                    disabled
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div >
        );
    }
}
export default inject('clientStore', 'commonStore')(withLocalization(observer(ParentalLeaves)));
